module.exports = __webpack_public_path__ + "static/img/background.88129d87.svg";